  // src/Container.jsx
  import React from "react";
  import ContentSection1 from "./ContentSection1";
  import Product from "./Product";
  import Services from "./Services";
  import FeaturedProducts from "./FeaturedProducts";
  import AboutUs from "./AboutUs"; 
  import Manufacturing from "./Manufacturing";
  import ManufacturingExcellence from "./ManufacturingExcellence";
  import Industries from "./Industries";
  import ValuedCustomers from "./ValuedCustomers";
  import "./Container.css";

  const Container = () => {
    return (
      <div className="container">

        <ContentSection1 />
        {/* SEO: the homepage previously had no <h1> anywhere in the server HTML
            -- the hero above is a pure image slider with no text. This is the
            page's one visible, semantic H1. */}
        <h1 className="home-hero-heading">
          Electronics Manufacturing, TFT Displays &amp; Embedded Design for OEMs
        </h1>
        <AboutUs />
        <ValuedCustomers />
        <Product />
        <FeaturedProducts/>
        <Services />
        <Manufacturing />
        <ManufacturingExcellence />
        <Industries />
      </div>
    );
  };

  export default Container;
